import Imm from 'immutable';
import { handleActions } from 'redux-actions';


export const defaultState = Imm.fromJS({
    access_token: null,
    user: {},
});

export default handleActions({
    AUTH: {
        LOGIN: (state, { payload }) => state.merge(Imm.fromJS(payload)),

        LOGOUT: () => defaultState,
    },
}, defaultState);
